module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAIBAMAAAA2IaO4AAAAAXNSR0IB2cksfwAAABJQTFRFAAAAAAAAAAAAAAAAAAAAAAAA4CsZogAAAAZ0Uk5TAND/EOAwXdceCQAAACdJREFUeJxjEFJSUmQwVFISZmAWUjRgYDBSZmBgYFKAESwggtWBAQA6iAJoQVIT9QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/v2/filter-icon.png
// module id = 309
// module chunks = 33